import {KennethMustDie} from "../KennethMustDie";
import {KMDReelsView} from "./KMDReelsView";
import {KMDSpecialReelModel} from "../reel/KMDSpecialReelModel";

export class KMDSpecialReelView extends KMDReelsView {
    private _reel: KMDSpecialReelModel;

    get reel(): KMDSpecialReelModel {
        return this._reel;
    }

    protected init(): void {
        this._symbolContainer = new PIXI.Container();
        this._symbolContainer.position.set(KennethMustDie.SYMBOL_WIDTH + KennethMustDie.SYMBOL_WIDTH / 2, KennethMustDie.SPECIAL_REEL_TOP);

        this._maskItem = new PIXI.Graphics();
        this._maskItem.beginFill();
        this._maskItem.drawRect(-(KennethMustDie.SYMBOL_WIDTH / 2), -(KennethMustDie.SYMBOL_HEIGHT / 2), KennethMustDie.SYMBOL_WIDTH * 3, KennethMustDie.SYMBOL_HEIGHT);
        this._maskItem.endFill();

        this._symbolContainer.addChild(this._maskItem);
        this._symbolContainer.mask = this._maskItem;

        this.addChild(this._symbolContainer);

        const reel: KMDSpecialReelModel = new KMDSpecialReelModel(KennethMustDie.REELS_NUM, this);
        reel.setReelSet(["L1", "L2", "L3", "L4", "L5", "M1", "M2", "M3", "M4", "M5", "W", "X_NUDGE_WILD", "X_WAYS"]);
        reel.stepSize = KennethMustDie.SYMBOL_WIDTH;
        reel.init(KennethMustDie.model.data.specialReels.concat());

        this._reel = reel;
    }
}